import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import ViewTitle from 'Common/components/ViewTitle/ViewTitle';
import { PageView } from 'Common/components/PageView/PageView';
import Header from 'Common/components/Header/Header';
import CatalogueSection from '../CatalogueSection/CatalogueSection.container';
const Page = ({ pageName, referrerState, }) => (_jsxs(PageView, Object.assign({ pageName: pageName, referrerState: referrerState }, { children: [_jsx(Header, { referrerState: referrerState }, void 0), _jsx(ViewTitle, { children: "Phenotype catalogue" }, void 0), _jsx(CatalogueSection, {}, void 0)] }), void 0));
export default memo(Page);
